<template>
  <span class="rf-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="check"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="22"
        height="22"
      >
        <path
          d="M12 22a9.97 9.97 0 0 0 10-10A9.97 9.97 0 0 0 12 2 9.97 9.97 0 0 0 2 12a9.97 9.97 0 0 0 10 10Z"
          fill="#fff"
          stroke="#fff"
          stroke-width="2"
          stroke-linejoin="round"
        />
        <path
          d="m8 12 3 3 6-6"
          stroke="#000"
          fill="transparent"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </mask>
      <g mask="url(#check)"><path d="M0 0h24v24H0V0Z" fill="inherit" stroke="none" /></g>
    </svg>
  </span>
</template>
